// extracted by mini-css-extract-plugin
module.exports = {"tags-container":"HeroTags_tags-container__WAK_j","tag":"HeroTags_tag__fAtlB","dot-divider":"HeroTags_dot-divider__Mm3O_"};